export default {
  app_api: 'https://pysq.shipook.com/v2app',
  base_api: 'https://pysq.shipook.com/v2base',
  qd: '110710',
  ver: '000001',
  uid: '',
  app_url: {
    synctts: '/peiyin/synctts', //tts合成接口
    ttsmixbgm: '/peiyin/ttsmixbgm', //背景音乐混音接口
    watermark: '/peiyin/watermark', //视频区水印接口
    qrybgmusicv5: '/peiyin/music/qrybgmusicv5', //查询背景音接口
    qryttszhubov5: '/peiyin/music/qryttszhubov5', //查询主播列表接口
    crtwork: '/peiyin/work/crtwork', //制作作品接口
    qryworklist: '/peiyin/work/qryworklist', //查询合成配音作品列表
    uptwork: '/peiyin/work/uptwork', //更新用户单条作品信息接口
    ttsmixbgmapp: '/peiyin/ttsmixbgmapp', //背景音混音接口
    qrysamplemusicv6: '/peiyin/music/qrysamplemusicv6', //查询成品录音
    qrylivespeakers: '/peiyin/music/qrylivespeakers', //查询真人样音
    ismultipinyin: '/peiyin/ismultipinyinapp', //多音字识别
    getmultipinyin: '/peiyin/getmultipinyinapp', //查询一个字的多音列表
    qryzhubodetail: '/peiyin/music/qryzhubodetail', //查询主播详情
    qryRealzhubov4: '/peiyin/music/qrylivespeakersv4', //查询真人主播列表接口
    qryDetail: '/peiyin/music/qrylivespeaker', //查询真人主播详情
    ttschangemp4app: '/peiyin/ttschangemp4app', //MP3转MP4
    ttsvoice: '/peiyin/ttsvoiceapp', //音量放大
    qrylist: '/peiyin/changesoundapp/qrylist', //音频变声特效列表
    changesoundapp: '/peiyin/changesoundapp', //音频变声接口
    qrysoundeffects: '/peiyin/music/qrysoundeffects', //音效列表接口
    ttsconcatapp: '/peiyin/ttsconcatapp', //音频拼接接口
    crtlivework: '/peiyin/work/crtlivework', //真人配音提交接口订单
    qryliveworklist: '/peiyin/work/qryliveworklist', //真人作品查询
    uptlivework: '/peiyin/work/uptlivework', //更新真人配音单条作品
    qrytextnum: '/peiyin/music/qrytextnum', //查询用户字符数
    qrytextnumv2: '/peiyin/music/qrytextnumv2', //查询用户字符数
    checkPcKey: "/pc/key/checkPcKey", //验证网站互通小程序的key
    qrycustombgmusicapp: '/peiyin/qrycustombgmusicapp', //查询自定义背景音乐
    crtcustombgmusicapp: '/peiyin/crtcustombgmusicapp', //上传自定义背景音乐
    qryapilimitapp: '/peiyin/qryapilimitapp', //查询Api使用次数
    uptapilimitapp: '/peiyin/uptapilimitapp', //更新Api使用次数
    setzbtemplate: '/peiyin/zbtemplat/setzbtemplate', //保存主播模板
    getzbtemplate: '/peiyin/zbtemplat/getzbtemplate', //获取主播模板
    updatazbtemplate: '/peiyin/zbtemplat/updatazbtemplate', //更新主播模板信息(删除)
    uptcustombgmusicapp: '/peiyin/uptcustombgmusicapp', //更新自定义背景音状态(删除)
    modifyMp3: '/peiyin/modifyMp3', //修改音频
    convertAudioFormat: '/peiyin/convertAudioFormat'//格式修改
  },
  base_url: {
    getqrcode4wxgzh: '/thirdlogin/getqrcode4wxgzh', //微信公众号登录获取二维码接口
    login4wechat: '/thirdlogin/login4wechat', //微信登录接口
    userlogout: '/user/userlogout', //退出登录
    qryuserallinfo: '/user/qryuserallinfo', //获取用户全部信息接口
    qryuserjbviplist: '/business/qryuserjbviplist', //获取开通vip列表接口
    openvip: '/business/openvip', //开通vip接口(获取支付二维码)
    qryorderinfo: '/business/qryorderinfo', //检测订单支付状态
    getsmscode: '/common/getsmscode', //短信验证码
    userlogin: '/user/userlogin', //用户登录接口(手机号登录)
    updateuserinfo: '/user/updateuserinfo', //更新用户信息接口
    qrycoupon: '/business/qrycoupon', //查询优惠卷
    getusercoupon: '/business/getusercoupon', //领取优惠卷
    qryusercoupon: '/business/qryusercoupon', //查询用户可用优惠卷
    cashorder: '/business/cashorder', //生成支付订单
    bootup: '/common/bootup', //设备启动接口
    qrycashrecharge: '/business/qrycashrecharge', //充值（现金消费）详细记录接口
  },
  showlogin: false, //登录界面显示状态
  show_anchor: false, //主播选择组件显示状态
  show_realAnchor: false, // 真人主播组件显示状态
  show_ploy: false, //多音字识别组件显示状态
  show_openvip: false, //开通会员组件显示状态
  login_state: false, //登录状态
  userinfo: {}, //用户身份信息
  userrich: {}, //用户财富信息
  anchor: {}, //选择主播信息
  anchor_list: [], //配音主播列表
  allrealist: [], //真人配音页全部真人主播列表
  reallist: [], //首页真人主播列表
  demolist: [], //首页样音示例列表
  real_anchor: '', //选择真人主播信息
  chose_music: {}, //所选案例
  bgd_music: {}, //所选背景音乐
  isbind: 0, //登录是否是绑定操作
  jblist: [], //金币充值列表
  ttsjblist: [], //作品现金购买价格列表
  zifubao: [], //字符包充值列表
  viptab: 0, //vip类型0普通，1超级
  allMusic: '', //所有背景音乐
}



// WEBPACK FOOTER //
// ./src/store/state.js